import React, { Component } from 'react'
import cn from 'classnames';


class FlashMessages extends Component {

  getClasses = (message) => {
    const bsStyle = cn({
      'alert-success': message.type === 'success' ? true : false,
      'alert-info': message.type === 'info' ? true : false,
      'alert-warning': message.type === 'warning' ? true : false,
      'alert-danger': message.type === 'danger' ? true : false,
      'show': !message.showed ? true : false,
      'hide': message.showed ? true : false,
      'alert': true,
      'alert-dismissible': true,
    });

    return bsStyle;
  }

  render() {
    const messages = this.props.messages;

    return (
      <div className="container">
        {messages.map(
          (message, id) => (
            <div key={id} className={this.getClasses(message)}>
              <button onClick={() => this.props.hideMessage({id})} type="button" className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              {message.text}
            </div>
          )
        )}
      </div>
    );
  }
}

export default FlashMessages;



// WEBPACK FOOTER //
// ./src/components/FlashMessages.js